import _ from "lodash";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";
import { IApiRegims, IItem } from "./api.model";

export class Regims {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/regim/`;
  private regims: IItem[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<IItem[]> {
    return this.$http.get<IApiRegims>(`${this.apiurl}findAll?`).then((response) => {
      this.regims = response.data.regims.map((o) => ({
        ...o,
        name: o.label,
        id: o.codi,
      }));
      this.regims = _.sortBy(_.filter(this.regims, (o: any) => o.acronim !== 'NA'), 'name');

      return this.regims;
    })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }
}

angularJsApp.service(AppServicesEnum.REGIMS_SERVICE, Regims);
